import script from "./resultList.vue?vue&type=script&setup=true&lang=js"
export * from "./resultList.vue?vue&type=script&setup=true&lang=js"

import "./resultList.vue?vue&type=style&index=0&id=f06b86fa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f06b86fa"]])

export default __exports__